const { saveCommandDevice } = require('../server/petitions/commands/saveCommands');
const { getCommandsDevice, sentCommandDevice } = require('../server/petitions/devices/commandsDevice');
const userViewModel = require('./userViewModel');

const CommandsViewModel = function () {
  const saveCommand = async (payload) => {
    const token = userViewModel.getToken();
    const response = await saveCommandDevice(token, payload);
    return response;
  };
  const sentCommand = async (payload) => {
    const token = userViewModel.getToken();
    const response = await sentCommandDevice(token, payload);

    return response;
  };
  const getCommands = async () => {
    const token = userViewModel.getToken();
    const response = await getCommandsDevice(token);

    return response;
  };

  return { saveCommand, getCommands, sentCommand };
};

module.exports = CommandsViewModel();
